import type { MarkedDay } from "@/contexts/AppContext";
import type { DBNotification } from "../types";

const DAILY_REMINDER_TYPES = new Set(["DAILY_REMINDER", "attendance"]);

function isDailyReminderNotif(notif: DBNotification): boolean {
  return (
    DAILY_REMINDER_TYPES.has(notif.type) ||
    notif.title.toLowerCase().includes("daily")
  );
}

/** Resolve the calendar day a daily-reminder notification applies to. */
export function dailyReminderAppliesToDate(notif: DBNotification): string {
  return notif.created_at.slice(0, 10);
}

/**
 * Returns notification IDs that should be hidden because attendance
 * confirmation is already surfaced via AttendanceCard / markedDays.
 */
export function getCoveredDailyReminderIds(
  inbox: DBNotification[],
  daysToConfirm: MarkedDay[],
  markedDays: MarkedDay[],
  todayStr: string,
): Set<string> {
  const confirmDates = new Set(daysToConfirm.map((d) => d.date));
  const hasMarkedToday = markedDays.some((d) => d.date === todayStr);

  const covered = new Set<string>();
  for (const notif of inbox) {
    if (!isDailyReminderNotif(notif)) continue;
    const appliesTo = dailyReminderAppliesToDate(notif);
    if (confirmDates.has(appliesTo)) {
      covered.add(notif.id);
      continue;
    }
    if (hasMarkedToday && appliesTo === todayStr) {
      covered.add(notif.id);
    }
  }
  return covered;
}
